<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Purchase Order - Cancellation </h1>
      <v-divider></v-divider>
      <Notification :notify="notify" />
      <div class="row mt-2">
        <div class="col">
          <v-stepper alt-labels v-model="step">
            <v-stepper-header>
              <v-stepper-step step="1">Order Details</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="2">Publications</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3">Lending</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="4">Cancel</v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </div>
      </div>

      <div class="mt-7">
          <div class="row" v-show="step == 1"> 
          <div class="col">
            <CancelPurchaseOrderDetails  @onSelect="onSelectOPDetails($event)"></CancelPurchaseOrderDetails>
            <!-- <PublisherList @onSelect="onSelectOPDetails($event)"></PublisherList> -->
          </div>
        </div>
        <div class="row" v-show="step == 2"> 
            <div class="col">
                <CancelPurchaseOrderPublication :organizationId="organizationId"></CancelPurchaseOrderPublication>
            </div>
        </div>
        <div class="row" v-show="step == 3"> 
            <div class="col">
                <CancelPurchaseOrderLending :organizationId="organizationId"></CancelPurchaseOrderLending>
            </div>
        </div>
        <div class="row" v-show="step == 4"> 
            <div class="col">
                <CancelPurchaseOrderLendingConfirmation :organizationId="organizationId"></CancelPurchaseOrderLendingConfirmation>
            </div>
        </div>
      </div>

        <!-- Steps ------------>
      <div class="row">
        <div class="col">
          <div class="float-left" v-show="step != 1">
            <v-btn color="primary" @click="onBack()" class="mt-4" id="btnBack">{{
              BackAction
            }}</v-btn>
          </div>
          <div class="float-right" v-show="step != 0 && step < 4">
            <v-btn color="primary" @click="onNext()" class="mt-4" id="btnNext">{{
              NextAction
            }}</v-btn>
          </div>
        </div>
      </div>
      <!----- End Steps -->

    </v-card>
  </div>
</template>

<script>
import * as api from "@/api";
import Notification from "@/components/Notification";
import Pagination from "@/components/Pagination";
import CancelPurchaseOrderDetails from "@/components/PO-Cancellation/CancelPurchaseOrderDetails";
import CancelPurchaseOrderPublication from "@/components/PO-Cancellation/CancelPurchaseOrderPublication";
import CancelPurchaseOrderLending from "@/components/PO-Cancellation/CancelPurchaseOrderLending";
import CancelPurchaseOrder from "@/components/PO-Cancellation/CancelPurchaseOrder";
import CancelPurchaseOrderLendingConfirmation from "@/components/PO-Cancellation/CancelPurchaseOrderLendingConfirmation";


export default {
  name: "PurchaseOrderCancel",
  components: {
    Notification,
    Pagination,
    CancelPurchaseOrderDetails,
    CancelPurchaseOrderPublication,
    CancelPurchaseOrderLending,
    CancelPurchaseOrder,
    CancelPurchaseOrderLendingConfirmation
  },
  created() {
    this.getPurchaseOrder(this.$route.params.id);
    this.organizationId = this.$route.params.organizationId
  },
  methods: {
    getPurchaseOrder(id) {
      new Promise((resolve, reject) => {
        api
          .getByID("purchase-order", id)
          .then((response) => {
            resolve(response);
            console.log(response.data);
            this.selectedObj = response.data;
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    onSelectOPDetails(item) {
      this.id = item;
      this.step = 2;
      this.notify.type = 0;
    },
    onBack() {
      this.step = this.step -= 1;
      this.notify.type = 0;
    },
    onNext() {
      this.step = this.step += 1;
      this.notify.type = 0;
    },
  },
  data() {
    return {
      id: 0,
      organizationId: 0,
      step: 1,
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      NextAction: "Next",
      BackAction: "Back",
      paging: { count: 10, page: 1, size: 5, keyword: "" },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/views/PurchaseOrderCancel.vue